// extracted by mini-css-extract-plugin
export default {"list":"QuoteList_list__eZI5R","sorting":"QuoteList_sorting__-nwPS"};